import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';
import Input from 'Components/Input';
import Icon from 'Components/Icon';

const SavedCouponName = props => {
  const buttonConfig = {
    primary: {
      label: EnvironmentManager.getMessageText({ key: 'coupon_saved_naming_button_saved' }) || 'KAYDET',
      onClick: props.onPrimaryButtonClick
    },
    secondary: {
      label: EnvironmentManager.getMessageText({ key: 'button_cancel' }) || 'VAZGEÇ',
      onClick: props.onSecondaryButtonClick
    }
  };

  const { clearInput, onChange, error, name } = props;

  return (
    <form className="saved-coupon-name" autoComplete="off">
      <div className="saved-coupon-name-icon">
        <Icon className="info-icon" iconName="svgInfoMainGreen" />
        <div className="saved-coupon-name-title">
          <span>{ EnvironmentManager.getMessageText({ key: 'title_coupon_saved_naming' }) || 'Kuponuna İsim Ver' }</span>
        </div>
        <div className="saved-coupon-name-desc">
          <span>{ EnvironmentManager.getMessageText({ key: 'coupon_saved_naming_desc' }) || 'Kuponunun ismi en az 3 karakter, en fazla 20 karakter olmalıdır.' }</span>
        </div>
      </div>
      <Input
        name="Kupon İsmi (Opsiyonel)"
        id='couponName'
        autocomplete="off"
        autoFocus
        onChange={ onChange }
        maxLength={ 20 }
        clearInput={ clearInput }
        value={ name }
      />
      <div className="saved-coupon-name-error">
        <span>{ error }</span>
      </div>
      <Message type='none' buttonConfig={ buttonConfig }/>
    </form>

  );
};

SavedCouponName.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  onSecondaryButtonClick: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  error: PropTypes.string,
  name: PropTypes.string,
  clearInput: PropTypes.func
};

export default SavedCouponName;
